export default __webpack_public_path__ + "css/InvoiceDetails.bundle.css";